import type { components } from '../api/schema';
import type { MessageKey } from '../i18n/en';

/** Тип карточки — из контракта API, чтобы новый тип на сервере сломал сборку, а не холст. */
export type NodeType = components['schemas']['DiagramNode']['type'];

/**
 * Порядок уровней сверху вниз (docs/architecture.md §2): уровень выводится из типа.
 * Повторяет `apps/api/src/modules/diagrams/domain/node-types.ts` — фронт не импортирует API.
 */
export const NODE_TYPES = [
  'HLRSC',
  'RSC',
  'RSCF',
  'CTRL',
  'ACR',
  'WP',
  'D',
  'C',
  'R',
  'M',
] as const satisfies readonly NodeType[];

// Список полный: тип, которого нет в NODE_TYPES, превращает условие в ошибку компиляции.
const exhaustive: [Exclude<NodeType, (typeof NODE_TYPES)[number]>] extends [never] ? true : never =
  true;
void exhaustive;

export function isNodeType(value: string): value is NodeType {
  return (NODE_TYPES as readonly string[]).includes(value);
}

/** Уровень 1–10. */
export function levelOf(type: NodeType): number {
  return NODE_TYPES.indexOf(type) + 1;
}

export function nodeTypeLabelKey(type: NodeType): MessageKey {
  return `nodeType.${type}`;
}

/** Цвета типа — CSS-переменные из styles/tokens.css. */
export function nodeTypeColors(type: NodeType): { bg: string; stroke: string; text: string } {
  const prefix = `--type-${type.toLowerCase()}`;
  return {
    bg: `var(${prefix}-bg)`,
    stroke: `var(${prefix}-stroke)`,
    text: `var(${prefix}-text)`,
  };
}
